import { Component, OnInit } from '@angular/core'
import { GnMappingReportService } from './gn-mapping-report.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ConfirmationModalComponent } from 'src/app/components/confirmation-modal/confirmation-modal.component';
import { AppConstants } from 'src/app/app.constants';
import { AssetService } from '../assets-management/assets.service';

@Component({
  selector: 'app-gn-mapping-report',
  templateUrl: './gn-mapping-report.component.html',
  styleUrls: ['./gn-mapping-report.component.scss'],
})
export class GnMappingReportComponent implements OnInit {
  reports: GnMappingReport[] = []
  amountMappedTitles: number
  totalMappedTitles: number
  amountCatalogTitlesSky: number
  amountCatalogTitlesSsla: number
  totalCatalogTitles: number
  currentDate = moment(Date.now()).set({
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  })
  startDate: Date = this.currentDate.clone().startOf('month').toDate()
  endDate: Date = this.currentDate.clone().endOf('month').startOf('day').toDate()
  getParams: PaginationParams = {
    page: 0,
    size: 20,
  }
  isLoading: boolean = false

  constructor(
    private gnMappingReportService: GnMappingReportService,
    private assetService: AssetService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.amountMappedTitles = 0
    this.totalMappedTitles = 0
    this.amountCatalogTitlesSky = 0
    this.amountCatalogTitlesSsla = 0
    this.totalCatalogTitles = 0
  }

  onDateChange(isStartDate: boolean, value: Date | string) {
    const selectedDate = moment(value).startOf('day').toDate()
    if (isStartDate) {
      this.startDate = selectedDate
    } else {
      this.endDate = selectedDate
    }
  }

  toUTCDate(value: Date, isEndOfDay: boolean = false): string {
    const date = moment.utc([
      value.getFullYear(),
      value.getMonth(),
      value.getDate(),
    ])

    return (isEndOfDay ? date.endOf('day') : date.startOf('day')).toISOString()
  }

  buildRequestBody() {
    return {
      startDate: this.toUTCDate(this.startDate),
      endDate: this.toUTCDate(this.endDate, true),
    }
  }

  onGenerateReport() {
    this.reset()
    this.getReport()
    this.getCounts()
  }

  onScroll(event: any) {
    event.preventDefault()
    const elem = event.target
    const limit = elem.scrollHeight - elem.clientHeight
    if (
      elem.scrollTop > 0 &&
      elem.scrollTop + 1 >= limit &&
      this.isLoading == false
    ) {
      elem.scrollTop -= this.reports.length
      this.getParams.page++
      this.getReport()
    }
  }

  getReport() {
    const body = this.buildRequestBody()

    this.isLoading = true
    this.gnMappingReportService
      .getReport(this.getParams, body)
      .subscribe((data: any) => {
        if (data?.response) {
          if (this.getParams.page < data?.totalPages) {
            if (this.getParams.page === 0) {
              this.reports = data.response
            } else {
              const newData = data.response
              this.reports.push(...newData)
            }
          } else {
            this.getParams.page--
            if (data?.totalPages === 0) {
              this.reports = []
            }
          }
        }
        this.isLoading = false
      })
  }

  getCounts() {
    const body = this.buildRequestBody()

    this.assetService.getAmountAssetMapped(body).subscribe((data : any) => {
      this.amountMappedTitles = data.response.amountMappedTitles
      this.totalMappedTitles = data.response.totalMappedTitles
      this.amountCatalogTitlesSky = data.response.amountCatalogTitlesSky
      this.amountCatalogTitlesSsla = data.response.amountCatalogTitlesSsla
      this.totalCatalogTitles = data.response.totalCatalogTitles
    })
  }

  onDownloadReport() {
    const body = this.buildRequestBody()

    const modal = this.modalService.open(ConfirmationModalComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
    })
    modal.componentInstance.title = 'Submit request'
    modal.componentInstance.message = `Do you want to download the report?`
    modal.componentInstance.isAlert = false
    modal.result.then((result) => {
      if (result) {
        this.isLoading = true;
        this.gnMappingReportService.download(body).subscribe({
            next: (response) => {
                if (response) {
                  this.isLoading = false
                  const blob = new Blob([response.body], { type: response.headers.get('content-type') })
                  let fileName = response.headers.get('content-disposition').split(';')[1]
                  fileName = fileName.replace('"','').split('=')[1]
                  let link = document.createElement('a')
                  link.href = window.URL.createObjectURL(blob)
                  link.download = fileName
                  link.click()
                  this.showAlert(AppConstants.SUCCESS, `File ${fileName} is downloaded successfully.`);
                }
            },
            error: (error) => {
              this.isLoading = false;
              this.showAlert(AppConstants.ERROR, `Failed to download the report.`);
              return;
            }
        });
      }
    })
  }

  showAlert(title: string, message: string) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
    })
    modalRef.componentInstance.title = title
    modalRef.componentInstance.message = message
    modalRef.componentInstance.isAlert = true
  }

  reset() {
    let container = document.getElementById('tableReport')
    if (container) {
      container.scrollTop = 0
    }
    this.getParams.page = 0
    this.amountMappedTitles = 0
    this.totalMappedTitles = 0
    this.amountCatalogTitlesSky = 0
    this.amountCatalogTitlesSsla = 0
    this.totalCatalogTitles = 0
  }

  calcPercent(
    current: number | null | undefined,
    total: number | null | undefined
  ): number {
    const c = Number(current) || 0
    const t = Number(total)
    if (!t || t <= 0) return 0
    const pct = (c / t) * 100
    return Math.min(100, Math.max(0, Math.round(pct)))
  }
}